import { render, staticRenderFns } from "./CardOutterTitle.vue?vue&type=template&id=106e9f38&scoped=true"
import script from "./CardOutterTitle.vue?vue&type=script&lang=js"
export * from "./CardOutterTitle.vue?vue&type=script&lang=js"
import style0 from "./CardOutterTitle.vue?vue&type=style&index=0&id=106e9f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106e9f38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
